import React, {useState} from 'react'
import Stepper from 'react-stepper-horizontal'
import UploadFile from './Step1/Step1'
import TruckDetails from './Step2/Step2'

/**
 * Function to start steps for bulk upload in truck master
 */
const TruckUploadExcel = ({truckMasterList, setTruckMasterList, companyId,superAdmins,emailTemplate}) => {
    const [step, setStep] = useState(0)
    const [uploadedData, setUploadedData] = useState([])

    return (
        <div>
            <Stepper 
                steps={[{title: 'Upload File'},
                    {title:'Check Your Truck Details'}]} 
                activeStep={step}
                completeColor={'#54a63a'}
                completeTitleColor={'#54a63a'}
                activeColor={'#393186'}
                activeTitleColor={'#393186'}
                titleFontSize={14} 
                size={28}
                circleFontSize={14}
            />
            {step === 0 ? 
                <UploadFile 
                    step={step}
                    setStep={setStep}
                    uploadedData={uploadedData}
                    setUploadedData={setUploadedData}
                    companyProfile={companyId}
                />
            : null}
            {step === 1? 
                <TruckDetails 
                    step={step}
                    setStep={setStep}
                    uploadedData={uploadedData}
                    setUploadedData={setUploadedData}
                    truckMasterList={truckMasterList}
                    setTruckMasterList={setTruckMasterList}
                    companyId={companyId}
                    superAdmins={superAdmins}
                    emailTemplate={emailTemplate}
                />
            :null}
        </div>
    )
}

export default TruckUploadExcel
